import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The DS scopes Tailwind under the `tw:` prefix (prefix(tw) in
// src/shadcn/styles/tailwind.css) so its utilities can't collide with the
// app's plain-CSS classes. tailwind-merge must be told about that prefix or it
// stops collapsing conflicting prefixed utilities — variant/className overrides
// would then silently fail to merge (no build error). See src/lib/cn.test.ts.
const twMerge = extendTailwindMerge({ prefix: 'tw' });

/** shadcn's standard class-merge helper, prefix-aware (`tw:`). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
